import styled from "styled-components";
import {
  LeadParagraph,
  media,
  spacing,
} from "@ops-gsic/cxp-component-library-react";

export const StyledText = styled.div`
  width: 75%;
`;
export const TextStyle = styled.div`
  margin-top: ${spacing.spacing6};
`;

export const CalloutContent = styled.div`
  display: flex;
  flex-wrap: wrap;

  svg {
    width: ${spacing.spacing5};
    height: ${spacing.spacing5};
    margin-right: ${spacing.spacing4};
  }
`;
export const DurationSpan = styled.span`
  display: inline-flex;
  white-space: pre;
`;

export const TextParagraphLg = styled(LeadParagraph)`
  margin-top: ${spacing.spacing5};
  margin-bottom: ${spacing.spacing7};
`;

export const BackLinkWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${spacing.spacing3};
  margin-bottom: ${spacing.spacing3};
  height: 3em;
`;
export const ButtonContainer = styled.div`
  margin-top: ${spacing.spacing5};

  @media ${media.small} {
    margin-top: ${spacing.spacing7};
  }

  button {
    margin-bottom: ${spacing.spacing7};
  }
`;

export default DurationSpan;
